import IGeoPlace from './geo-place.interface';

export class GeoPlace implements IGeoPlace {
  get longitude(): number {
    return this._longitude;
  }

  set longitude(value: number) {
    this._longitude = value;
  }

  get latitude(): number {
    return this._latitude;
  }

  set latitude(value: number) {
    this._latitude = value;
  }

  altitude: number;
  geoFenceRadius: number;
  geoPlaceId: number;
  geoPlaceType: string;
  private _latitude = 0;
  private _longitude = 0;

  constructor(geoPlace: IGeoPlace) {
    Object.keys(geoPlace).forEach((key: string) => {
      if (geoPlace[key]) {
        this[key] = geoPlace[key];
      }
    });
  }

  /**
   * Locations not at (0,0) are deemed to be valid.
   *
   * Locations at (0,0) are in the Pacific Ocean, south of Ghana and near the Gulf of Guinea.
   * Cement probably won't be delivered there.
   *
   * @returns boolean
   */
  get isNonZeroLocation(): boolean {
    return this._latitude !== 0 || this._longitude !== 0;
  }

  /**
   * Provides a latitude and longitude in degrees, minutes and seconds.
   * @returns string
   */
  convertDMS(): string {
    if (!this.latitude || !this.longitude) {
      return null;
    }

    const lng = this._longitude;
    const lat = this._latitude;
    const convertLat = Math.abs(lat);
    const LatDeg = Math.floor(convertLat);
    const LatMin = Math.floor((convertLat - LatDeg) * 60);
    const LatSec = Math.round((convertLat - LatDeg - LatMin / 60) * 3600 * 1000) / 1000;
    const LatCardinal = lat > 0 ? 'N' : 'S';

    const convertLng = Math.abs(lng);
    const LngDeg = Math.floor(convertLng);
    const LngMin = Math.floor((convertLng - LngDeg) * 60);
    const LngSec = Math.round((convertLng - LngDeg - LngMin / 60) * 3600 * 1000) / 1000;
    const LngCardinal = lng > 0 ? 'E' : 'W';

    return `${LatDeg}° ${LatMin}' ${LatSec}"${LatCardinal} ${LngDeg}° ${LngMin}' ${LngSec}"${LngCardinal}`;
  }
}

export default GeoPlace;
